import * as blUrls from 'lib/urls'
import { SocialLink } from 'shared/Footer/SocialLinks/SocialLinks.types'
import {
  InstagramIcon,
  LinkedInIcon,
  XIcon,
} from 'shared/Footer/SocialLinks/icons'
import { TikTokIcon } from 'components/icons'

export const socialLinks: SocialLink[] = [
  {
    Component: TikTokIcon,
    href: blUrls.tiktokUrl,
    name: 'TikTok',
  },
  {
    Component: InstagramIcon,
    href: blUrls.instagramUrl,
    name: 'Instagram',
  },
  {
    icon: 'fa-facebook-official',
    href: blUrls.facebookUrl,
    name: 'Facebook',
  },
  {
    Component: LinkedInIcon,
    href: blUrls.linkedInUrl,
    name: 'LinkedIn',
  },
  {
    icon: 'fa-youtube-play',
    href: blUrls.youtubeUrl,
    name: 'Youtube',
  },
  {
    Component: XIcon,
    href: blUrls.twitterUrl,
    name: 'Twitter',
  },
  {
    icon: 'fa-pinterest',
    href: blUrls.pinterestUrl,
    name: 'Pinterest',
  },
]
